import type { HtmlFragmentDefinition, HtmlNodeDefinition, HtmlTagDefinition } from '#shared/model/html'

function insertLinksIntoText(text: string): HtmlFragmentDefinition {
  const result: HtmlFragmentDefinition = []
  const linkRegex =
    /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/gm

  const matches = text.matchAll(linkRegex)

  let startPos = 0
  for (const match of matches) {
    result.push(text.slice(startPos, match.index))
    const href = match.toString()
    result.push({
      tag: 'a',
      attrs: {
        href,
        kind: 'emphasized',
      },
    })
    startPos = match.index + href.length
  }

  if (startPos < text.length) {
    result.push(text.slice(startPos))
  }

  return result
}

function insertLinksIntoTag(node: HtmlTagDefinition): HtmlTagDefinition {
  if (node.tag === 'a') return node
  if (!node.content) return node

  const newNode: HtmlTagDefinition = {
    tag: node.tag,
    attrs: node.attrs,
    content: [],
  }

  if (typeof node.content === 'string') {
    newNode.content = insertLinksIntoText(node.content)
  } else if (Array.isArray(node.content)) {
    const newContent: HtmlNodeDefinition[] = []

    for (const nodeChild of node.content) {
      if (!nodeChild) {
        newContent.push(nodeChild)
        continue
      }

      if (typeof nodeChild === 'number') {
        newContent.push(nodeChild)
        continue
      }

      if (typeof nodeChild === 'string') {
        const transformedNodeChild = insertLinksIntoText(nodeChild)

        if (Array.isArray(transformedNodeChild)) {
          newContent.push(...transformedNodeChild)
        } else {
          newContent.push(transformedNodeChild)
        }

        continue
      }

      newContent.push(insertLinksIntoTag(nodeChild))
    }

    newNode.content = newContent
  }

  return newNode
}

export function insertMessageLinks(content: HtmlFragmentDefinition): HtmlFragmentDefinition {
  if (!content) return content

  if (typeof content === 'number') return content

  if (typeof content === 'string') {
    return insertLinksIntoText(content)
  }

  if (Array.isArray(content)) {
    const newContent: HtmlNodeDefinition[] = []

    for (const nodeChild of content) {
      if (!nodeChild) {
        newContent.push(nodeChild)
        continue
      }

      if (typeof nodeChild === 'number') {
        newContent.push(nodeChild)
        continue
      }

      if (typeof nodeChild === 'string') {
        const transformedNodeChild = insertLinksIntoText(nodeChild)

        if (Array.isArray(transformedNodeChild)) {
          newContent.push(...transformedNodeChild)
        } else {
          newContent.push(transformedNodeChild)
        }

        continue
      }

      newContent.push(insertLinksIntoTag(nodeChild))
    }

    return newContent
  }

  return insertLinksIntoTag(content)
}

// @ts-ignore
window.insertMessageLinks = insertMessageLinks
